export const CHECK_ADDRESS_ERROR = {
  transformation_regex: /\s+/g,
  default_separator: '_',
  default_split_key: ': ',
  messages: {
    default: 'Invalid address',
    invalidAddress: 'invalid_address',
    incorrectCity: 'incorrect_city',
    incorrectState: 'incorrect_state',
    incorrectPostalCode: 'incorrect_postal_code',
    unknownStreet: 'unknown_street',
  },
};

export const PERSONAL_INFORMATION_FIELDS = [
  'legal_first_name',
  'legal_last_name',
  'middle_name',
  'decrypted_ssn',
  'contractor_info_decrypted_ein',
  'date_of_birth',
  'zip_code',
  'address_id',
  'address_1',
  'address_2',
  'city',
  'state',
  'contractor_info_id',
  'contractor_info_business_name',
  'contractor_info_decrypted_ein',
  'is_remote',
];

export const ITIN_LINK =
  'https://www.irs.gov/individuals/individual-taxpayer-identification-number';
